import { render, staticRenderFns } from "./CenterViewEventCreateDesign_Ap.vue?vue&type=template&id=70d473a4&scoped=true"
import script from "./CenterViewEventCreateDesign_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewEventCreateDesign_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewEventCreateDesign_Ap.vue?vue&type=style&index=0&id=70d473a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d473a4",
  null
  
)

export default component.exports